import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

import { BarChart } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import Card from '../Card';
import SemDados from '../SemDados';

function CardHorariosPicos({ legendaPosto, data, mostrarMedia, style }) {
  const [chartSeries, setChartSeries] = useState(null);
  const horas = data.map((value) => value.hora);
  const percentuais = data.map((value) => value.percentual);
  const mediaPercentuais = data.map((value) => value.percentualgeral);
  const quantidades = data.map((value) => value.quantidadeabastecimentos);

  useEffect(() => {
    if (data && Array.isArray(data) && data.length === 24) {
      const series = [
        {
          name: legendaPosto,
          type: 'bar',
          data: percentuais,
        },
      ];

      if (mostrarMedia) {
        series.push({
          name: t('s.dashboard.visaogeral.mediageral'),
          type: 'line',
          data: mediaPercentuais,
          marker: {
            size: 5,
            colors: ['green'],
          },
          stroke: {
            width: 2,
            curve: 'smooth',
            colors: ['green'],
          },
        });
      }

      setChartSeries(series);
    } else {
      setChartSeries(null);
    }
  }, [data, legendaPosto]);

  return (
    <Card
      title={t('s.dashboard.visaogeral.horariopico')}
      icon={<BarChart />}
      tooltip={t('s.dashboard.visaogeral.tooltip.horariopico')}
      style={style}
    >
      {chartSeries ? (
        <Chart
          type="bar"
          series={chartSeries}
          width="100%"
          height="90%"
          options={{
            colors: ['#4791db', '#008000'],
            chart: {
              id: 'horarios-pico-abastecimentos',
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            xaxis: {
              categories: horas,
              axisTicks: {
                show: true,
                borderType: 'solid',
                height: 6,
                offsetX: 0,
                offsetY: 0,
              },
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: [1],
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '80%',
              },
            },
            stroke: {
              width: [0, 2],
              curve: 'smooth',
            },
            tooltip: {
              shared: true,
              intersect: false,
              x: {
                formatter(val) {
                  return `${val}:00`;
                },
              },
              y: {
                formatter(val, opts) {
                  if (opts.seriesIndex === 0) {
                    const quantidade = quantidades[opts.dataPointIndex];

                    return `${number(val, 2)} % (${quantidade} ${t(
                      's.operacao.turno.abastecimentos'
                    )})`;
                  }

                  return `${number(val, 2)} %`;
                },
              },
            },
            yaxis: {
              labels: {
                formatter(val) {
                  return `${Math.round(val)} %`;
                },
              },
              min: 0,
              max(max) {
                if (max < 100) return max; // Ensure max is at least 100%
                if (max > 100) return 100;
                return 100;
              },
              tickAmount: 4,
            },
            responsive: [
              {
                breakpoint: undefined,
                options: {
                  chart: {
                    width: '100%',
                  },
                },
              },
            ],
          }}
        />
      ) : (
        <SemDados />
      )}
    </Card>
  );
}

CardHorariosPicos.propTypes = {
  legendaPosto: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      hora: PropTypes.number.isRequired,
      percentual: PropTypes.number.isRequired,
      percentualgeral: PropTypes.number.isRequired,
      quantidadeabastecimentos: PropTypes.number.isRequired,
    })
  ).isRequired,

  mostrarMedia: PropTypes.bool.isRequired,
  style: PropTypes.objectOf(PropTypes.any),
};

CardHorariosPicos.defaultProps = {
  style: {},
};

export default CardHorariosPicos;
